import React from 'react'
import { useStyles } from './button-group.style'

export const ButtonGroup = function ({ children, className = '', variant = '', ...props }) {
  const classes = useStyles()
  return (
    <div className={`${classes.buttonGroup} ${className}`} {...props}>
      {children.map((child, index) => {
        let buttonClass

        if (index === 0) {
          buttonClass = classes.firstButton
        } else if (index === (children.length - 1)) {
          buttonClass = classes.lastButton
        } else {
          buttonClass = classes.insideButton
        }

        return React.cloneElement(child, {
          key: index,
          className: buttonClass,
          variant
        })
      })}
    </div>
  )
}
